import React from 'react'
import { DataCard } from './styles'
import ComponentLoader from 'components/ComponentLoader'


interface IDataCardLoaderProps {

  mainContainerStyle?: string
}
export default function DataCardLoader({ mainContainerStyle }: IDataCardLoaderProps) {
  return (
    <DataCard data-testid="test-card-loader" className={`${mainContainerStyle} flex justify-center align-middle items-center`}>
      <div className='w-[40px] h-[40px] rounded-full bg-white shadow-md'>
        <img src={`/loader-branco.gif`} />
      </div>
    </DataCard>
  )
}
